
export class MediaQueryTool   {

    constructor()   {

        this._hasCoarsePointer = false;
        this._hasFinePointer = false;
        this._hasHover = false;

        this._hasPrimaryCoarsePointer = false;
        this._hasPrimaryFinePointer = false;
        this._hasPrimaryHover = false;

        this.update();
    }

    get hasCoarsePointer() {
        return this._hasCoarsePointer;
    }

    get hasFinePointer() {
        return this._hasFinePointer;
    }

    get hasHover() {
        return this._hasHover;
    }

    get hasPrimaryCoarsePointer() {
        return this._hasPrimaryCoarsePointer;
    }

    get hasPrimaryFinePointer() {
        return this._hasPrimaryFinePointer;
    }

    get hasPrimaryHover() {
        return this._hasPrimaryHover;
    }

    matchMedia(mediaQueryString)    {
        if(typeof(window.matchMedia) !== 'function')    return {matches: false, media: mediaQueryString};
        return window.matchMedia(mediaQueryString);
    }

    update()    {
        this._hasCoarsePointer = this.matchMedia('(any-pointer: coarse)').matches;
        this._hasFinePointer = this.matchMedia('(any-pointer: fine)').matches;
        this._hasHover = this.matchMedia('(any-hover: hover)').matches;

        this._hasPrimaryCoarsePointer = this.matchMedia('(pointer: coarse)').matches;
        this._hasPrimaryFinePointer = this.matchMedia('(pointer: fine)').matches;
        this._hasPrimaryHover = this.matchMedia('(hover: hover)').matches;
    }
};

export default new MediaQueryTool();